export * from "ce/pages/AdminSettings";
import { default as CE_Settings } from "ce/pages/AdminSettings";
export default CE_Settings;
